import { render, staticRenderFns } from "./tableDynamic.vue?vue&type=template&id=615a2cb9"
import script from "./tableDynamic.vue?vue&type=script&lang=js"
export * from "./tableDynamic.vue?vue&type=script&lang=js"
import style0 from "./tableDynamic.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports